import React from 'react';
import Icon from './Icon';
import { fonts } from '../theme';

export function Eyebrow({ children, t, mono = true, color }) {
  return (
    <div style={{
      fontFamily: mono ? fonts.mono : fonts.sans,
      fontSize: 10, fontWeight: 500, letterSpacing: '0.18em',
      textTransform: 'uppercase',
      color: color || (t ? t.muted : '#5b6660'),
      display: 'flex', alignItems: 'center', gap: 8,
    }}>
      <span style={{ display: 'inline-block', width: 14, height: 1, background: 'currentColor', opacity: 0.5 }} />
      <span>{children}</span>
    </div>
  );
}

export function Pill({ children, onClick, fill, ink, t, style = {}, icon, type = 'button' }) {
  return (
    <button type={type} onClick={onClick} style={{
      appearance: 'none', border: 'none', cursor: 'pointer',
      background: fill || t.ink, color: ink || t.paper,
      borderRadius: 999, padding: '14px 20px',
      fontFamily: fonts.sans, fontSize: 14, fontWeight: 500, letterSpacing: '-0.01em',
      display: 'inline-flex', alignItems: 'center', gap: 8,
      transition: 'transform .15s, opacity .15s',
      ...style,
    }}>
      <span>{children}</span>
      {icon !== false && <Icon name={icon || 'arrow-up-right'} size={16} sw={1.75} />}
    </button>
  );
}

export function SectionStamp({ n, label, t }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'baseline', gap: 8,
      fontFamily: fonts.mono, fontSize: 11, color: t.muted,
      textTransform: 'uppercase', letterSpacing: '0.16em',
    }}>
      <span style={{ fontFeatureSettings: '"tnum"' }}>{n}</span>
      <span style={{ display: 'inline-block', width: 18, height: 1, background: 'currentColor', opacity: 0.4 }} />
      <span>{label}</span>
    </div>
  );
}
